// @flow
/* eslint no-process-env:0 */
import React from "react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "../components/privateRoute/PrivateRoute";
import loginConnected from "../views/login";
import HomeConnected from "../views/home";
import AlertConnected from "../views/alert";
import BasicElementsConnected from "../views/basicElements";
import BasicProgressBarConnected from "../views/basicProgressBar";
import BreadcrumbViewConnected from "../views/breadcrumb";
import EarningGraphConnected from "../views/earningGraph";
import GeneralConnected from "../views/general";
import NotificationsConnected from "../views/notifications";
import PaginationViewConnected from "../views/pagination";
import SimpleTablesConnected from "../views/simpleTables";
import StatViewConnected from "../views/stat";
import StatsCardConnected from "../views/statsCard";
import StripedProgressBarConnected from "../views/stripedProgressBar";
import TabPanelConnected from "../views/tabPanel";
import TeamMatesViewConnected from "../views/teamMates";
import TodoListViewConnected from "../views/todoList";
import TwitterFeedConnected from "../views/twitterFeed";
import WorkProgressConnected from "../views/workProgress";
import ProtectedConnected from "../views/protected";
import CategoriesConnected from "../views/categories";

import Announcements from "../views/announcements";
import AddAnnouncements from "../views/announcements/AddAnnouncements";

import Banners from "../views/banners";
import AddBanners from "../views/banners/AddBanners";
import EditBanners from "../views/banners/EditBanners";

import CityAndCountry from "../views/cityAndCountry";
import AddCity from "../views/cityAndCountry/AddCity";
import CityStateCountryDetails from "../views/cityAndCountry/cityStateCountryDetails";

import Invoices from "../views/invoices";
import AddInvoices from "../views/invoices/AddInvoices";
import PaidInvoices from "../views/invoices/PaidInvoices";
import InvoicesDetails from "../views/invoices/InvoicesDetails";

import AddCategoryConnected from "../views/addCategory";
import ManageSiteConnected from "../views/manageSite";
import StepOneConnected from "../views/manageSite/steps/StepOne";
import ViewSiteListComponent from "../views/manageSite/viewSiteList";
import ViewSiteInactiveListComponent from "../views/manageSite/viewSiteInactiveList";
import ViewSiteDetail from "../views/manageSite/viewSiteList/viewSiteDetail";
import SearchConnected from "../views/home/Search";
import MonthlyReport from "../views/monthlyReport";
import RevenueSite from "../views/revenueSite";
import SuperAdminList from "../views/Users/SuperAdmin/List";
import SuperAdminAdd from "../views/Users/SuperAdmin/Add";
import SuperAdminEdit from "../views/Users/SuperAdmin/Edit";
import SubAdminList from "../views/Users/SubAdmin/List";
import SubAdminEdit from "../views/Users/SubAdmin/Edit";
import SubAdminAdd from "../views/Users/SubAdmin/Add";
import SSLList from "../views/importSSL/List";

import InvoiceReport from "../views/invoices/InvoiceReport";
const MainRoutes = () => (
  <Switch>
<Route exact path="/home" component={HomeConnected} />
    <Route exact path="/cityAndCountry" component={CityAndCountry} />
    <Route exact path="/AddCity" component={AddCity} />
    <Route exact path="/AddCity/:cityId?" component={AddCity} />
    <Route
      exact
      path="/CityStateCountryDetails/:cityId?"
      component={CityStateCountryDetails}
    />
    <Route exact path="/announcements" component={Announcements} />
    <Route exact path="/AddAnnouncements" component={AddAnnouncements} />
    <Route
      exact
      path="/AddAnnouncements/:announcementsId?"
      component={AddAnnouncements}
    />

    <Route exact path="/banners" component={Banners} />
    <Route exact path="/AddBanners" component={AddBanners} />
    <Route exact path="/EditBanners/:bannersId?" component={EditBanners} />

    <Route exact path="/invoices" component={Invoices} />
    <Route exact path="/PaidInvoices" component={PaidInvoices} />
        <Route exact path="/InvoiceReport" component={InvoiceReport} />
    
    <Route exact path="/AddInvoices" component={AddInvoices} />
    <Route exact path="/AddInvoices/:invoicesId?" component={AddInvoices} />
    <Route
      exact
      path="/InvoicesDetails/:invoicesId?"
      component={InvoicesDetails}
    />
    <Route
      exact
      path="/search/:filterType?/:filterText?"
      component={SearchConnected}
    />
    <Route path="/Dashboard/statsCard" component={StatsCardConnected} />
    <Route path="/Dashboard/earningGraph" component={EarningGraphConnected} />
    <Route path="/Dashboard/notifications" component={NotificationsConnected} />
    <Route path="/Dashboard/workProgress" component={WorkProgressConnected} />
    <Route path="/Dashboard/twitterFeed" component={TwitterFeedConnected} />
    <Route path="/Dashboard/teamMates" component={TeamMatesViewConnected} />
    <Route path="/Dashboard/todoList" component={TodoListViewConnected} />

    <Route exact path="/simpleTables" component={SimpleTablesConnected} />
    <Route exact path="/basicElements" component={BasicElementsConnected} />

    <Route exact path="/categories" component={CategoriesConnected} />
    <Route path="/categories/addCategory" component={AddCategoryConnected} />

    <Route exact path="/general" component={GeneralConnected} />
    <Route path="/general/breadcrumb" component={BreadcrumbViewConnected} />
    <Route path="/general/stat" component={StatViewConnected} />
    <Route
      path="/general/basicProgressBars"
      component={BasicProgressBarConnected}
    />
    <Route path="/general/tabPanels" component={TabPanelConnected} />
    <Route
      path="/general/stripedProgressBars"
      component={StripedProgressBarConnected}
    />
    <Route path="/general/alerts" component={AlertConnected} />
    <Route path="/general/pagination" component={PaginationViewConnected} />

    <Route exact path="/manageSite" component={ManageSiteConnected} />
    <Route path="/manageSite/:siteid?" component={ManageSiteConnected} />

    <Route path="/manageSite/steps/StepOne" component={StepOneConnected} />
    <Route path="/viewSiteList" component={ViewSiteListComponent} />
    <Route
      path="/ViewSiteInactiveList"
      component={ViewSiteInactiveListComponent}
    />
    <Route path="/viewSiteDetail/" component={ViewSiteDetail} />
    <Route path="/report/sales" component={MonthlyReport} />
    <Route path="/report/revenueSite" component={RevenueSite} />
    <Route path="/superadmin/list" component={SuperAdminList} />
    <Route path="/superadmin/add" component={SuperAdminAdd} />
    <Route path="/superadmin/edit/:user_id?" component={SuperAdminEdit} />
    <Route path="/subadmin/list" component={SubAdminList} />
    <Route path="/subadmin/edit/:user_id?" component={SubAdminEdit} />
    <Route path="/subadmin/add" component={SubAdminAdd} />
    <Route path="/ssl/list" component={SSLList} />
  </Switch>
);

export default MainRoutes;



// WEBPACK FOOTER //
// ./src/app/routes/MainRoutes.js